import { z } from "zod";

export const ReportStatusSchema = z.enum(["pending", "generating", "complete", "error"]);
export type ReportStatus = z.infer<typeof ReportStatusSchema>;

export const DailyReportSummarySchema = z.object({
  report_date: z.string().date(),
  status: ReportStatusSchema,
  cycle_completed_at: z.string().datetime({ offset: true }).nullable(),
  invoices_processed: z.number().int().min(0),
  payments_matched: z.number().int().min(0),
  emails_sent: z.number().int().min(0),
  costs_classified: z.number().int().min(0),
});
export type DailyReportSummary = z.infer<typeof DailyReportSummarySchema>;

export const EmailActionSummarySchema = z.object({
  client_name: z.string(),
  email_to: z.string(),
  action_type: z.enum(["pre_due_reminder", "overdue_reminder", "formal_demand"]),
  invoice_count: z.number().int().min(1),
  max_days_overdue: z.number().int().min(0),
  status: z.enum(["sent", "failed", "skipped"]),
});
export type EmailActionSummary = z.infer<typeof EmailActionSummarySchema>;

export const CostTotalsByCategorySchema = z.object({
  fixed_cost: z.string(),
  current_cost: z.string(),
  zus: z.string(),
  pit4: z.string(),
  cit: z.string(),
  vat_tax: z.string(),
  salary: z.string(),
});

export const SkippedClientSummarySchema = z.object({
  client_id: z.string().uuid(),
  client_name: z.string(),
  reason: z.enum(["no_email"]),
});
export type SkippedClientSummary = z.infer<typeof SkippedClientSummarySchema>;

export const DailyReportSchema = z.object({
  report_date: z.string().date(),
  generated_at: z.string().datetime({ offset: true }),
  debt_collection: z.object({
    active_clients: z.array(z.unknown()),
    excluded_clients: z.array(z.unknown()),
    emails_sent: z.array(EmailActionSummarySchema),
    skipped_clients: z.array(SkippedClientSummarySchema),
    newly_paid_invoices: z.array(z.unknown()),
    unmatched_payments: z.array(z.unknown()),
  }),
  costs: z.object({
    entries_classified: z.number().int().min(0),
    ignored_technical_vat: z.number().int().min(0),
    totals_by_category: CostTotalsByCategorySchema,
  }),
});
export type DailyReport = z.infer<typeof DailyReportSchema>;

export const ReportListResponseSchema = z.object({
  reports: z.array(DailyReportSummarySchema),
});
export type ReportListResponse = z.infer<typeof ReportListResponseSchema>;
